export const platformSkillRouteId = 'skills'
